import AuthorizationActivities from './AuthorizationActivities'
import BrowserNotification from './BrowserNotification'
import Connection from 'components/Connection'
import DynamicFavicon from './DynamicFavicon'
import LightBox from './LightBox'
import Navigation from './Navigation'
import React from 'react'
import Toast from './Toast'
import ninchatClient from '../api/NinchatClient'

window.addEventListener('beforeunload', () => ninchatClient.close())

const AppMain = (): React.ReactElement => (
    <>
        <Toast />
        <Connection />
        <BrowserNotification />
        <DynamicFavicon />
        <AuthorizationActivities />
        <LightBox />
        <Navigation />
    </>

)

export default AppMain
